"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
function updateUserConfiguration(settingUpdates, configurationName) {
    if (configurationName === void 0) { configurationName = 'OWA.UserOptions'; }
    return updateUserConfiguration_1.default(configurationName, settingUpdates.map(function (update) {
        return userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: [update.propertyName],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: update.propertyType,
                Value: Array.isArray(update.propertyValue)
                    ? update.propertyValue
                    : [update.propertyValue],
            }),
        });
    }));
}
exports.default = updateUserConfiguration;
//# sourceMappingURL=updateUserConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/services/updateUserConfiguration.js
// module id = 1826
// module chunks = 2 39 105 108